import { render, staticRenderFns } from "./SB.vue?vue&type=template&id=2a938fc3"
import script from "./SB.vue?vue&type=script&lang=js"
export * from "./SB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports